import gql from 'graphql-tag'

export const GET_VEHICLE_VIDEO_LIST = gql`
query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
  vehicleVideoTrackers(filter: $filter) {
    isSuccessful
    message
    vehicleVideoTrackers {
      calculatedMotionStatus
      motionStatus
      vehicleId
      vehicle {
        licensePlate
        imei
        vehicleType {
          category
          manufacturer
          model
          type
        }
        driver1 {
          fullname
        }
        driver2 {
          fullname
        }
        device {
          imei
          phoneNo
        }
      }
    }
  }
}
`

export const SET_VIDEO_STREAM_STATUS = gql`
mutation SetVideoStreamStatus($input: SetVideoStreamStatusInput!) {
  setVideoStreamStatus(input: $input) {
    isSuccessful
    message
    setVideoStreamStatus {
      imei
      status
    }
  }
}
`